import AuthenticatedRequest from "services/requests/Authenticated";
import apiUrlConfig from "configs/apiUrlConfig";

const URLS = {
  FETCH: `${apiUrlConfig.apiEndPoint()}/plans`
};

class PlansApi {
  static getAll() {
    return AuthenticatedRequest.get(URLS.FETCH);
  }
}

export default PlansApi;



// WEBPACK FOOTER //
// ./src/apis/Plans.js